export default "__VITE_ASSET__BYXFVCqg__"